module.exports = __webpack_public_path__ + "static/media/O2.3a2016e0.jpeg";